<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(price)="data">
        {{ Number(data.item.price).toFixed(2) }}
      </template>
      <template v-slot:cell(feeSubtotal)="data">
        {{ Number(data.item.feeSubtotal).toFixed(2) }}
      </template>
      <template v-slot:cell(remark)="data">
        <div style="color: #4caedc;" @click="showDetail(data.item.remark)">{{ data.item.remark }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(feeSubtotal)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'feeSubtotal') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";

export default {
  name: "ItsColdStorageFeeDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'feeName', label: '单价名称', width: '120px'},
        {key: 'price', label: '单价', width: '100px'},
        {key: 'priceUnit', label: '单位', width: '80px'},
        {key: 'quantity', label: '数量', width: '100px'},
        {key: 'quantityUnit', label: '单位', width: '80px'},
        {key: 'feeSubtotal', label: '费用小计（元）', width: '120px'},
        {key: 'remark', label: '备注', width: '100px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (!content || content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>

</style>
